<template>
    <div class="row">
        <div class="col-12">
            <v-file-uploader :accept="['ddd']" v-model="value" multiple value-parameter="Files"></v-file-uploader>
        </div>
    </div>
</template>

<script>
import VFileUploader from '@/components/v-file-uploader/VFileUploader'
export default {
    components:{
        VFileUploader
    },
    props:{
        value:Object,
    },
}
</script>

<style>

</style>